import React, { Fragment, useEffect, useState } from 'react';
import { asset } from 'Utils/envLoader';
import { getAccesses, getApps, postAccesses, deleteAccesses } from 'Services/CliamService';
import userService from 'Services/UserService';
// import { Link } from "react-router-dom";
import { Table, Modal } from 'react-bootstrap';
import { AiOutlinePlusCircle, AiOutlineUserAdd } from 'react-icons/ai';
import { GoTrashcan } from 'react-icons/go';

import { toast } from 'react-toastify';

const Apps = (props) => {
    const [show, setShow] = useState(false);
    const [targetUser, setTargetUser] = useState(null);
    const [apps, setApps] = useState([]);
    const [accesses, setAccesses] = useState([]);
    const {
        match: { params },
    } = props;

    useEffect(() => {
        if (params.userId) {
            getAccesses(params.userId)
                .then((result) => {
                    console.log(result);
                    setAccesses(result);
                })
                .catch((e) => {
                    console.log(e);
                });

            getApps()
                .then((result) => {
                    setApps(result);
                })
                .catch((e) => {
                    console.log(e);
                });

            userService
                .getUserById(params.userId)
                .then((result) => {
                    if (result.status === 200) {
                        setTargetUser(result.data);
                    }
                })
                .catch((e) => {
                    console.log(e);
                });
        }
    }, [params.userId]);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const createAccess = (appId) => {
        const data = {
            AppId: appId,
            UserId: params.userId,
        };

        postAccesses(data)
            .then((result) => {
                setAccesses([...accesses, result]);
                handleClose();
                toast.success('Access Created Successfully');
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const deleteAccess = (AccessId) => {
        deleteAccesses(AccessId)
            .then(() => {
                const data = accesses.filter((item) => {
                    return item.accessId !== AccessId;
                });

                // console.log(accesses, result.data));
                setAccesses(data);
                handleClose();
                toast.warn('Access Deleted Successfully');
            })
            .catch((e) => {
                console.log(e);
            });
    };

    return (
        <Fragment>
            <>
                <div className="d-flex justify-content-between align-items-center py-2">
                    <h2>{targetUser && `${targetUser.lastName} ${targetUser.firstName}`} &gt; Access</h2>

                    <button className="btn btn-outline-primary btn-sm" onClick={handleShow}>
                        <AiOutlinePlusCircle></AiOutlinePlusCircle>
                        <span className="ml-1">New</span>
                    </button>
                    {/* <Button
						className="btn btn-primary btn-sm"
						onClick={handleShow}
					>
						<img
							src="/images/add.svg"
							alt="web"
							style={{ width: "10pt", marginRight: "3pt" }}
						/>
						New
					</Button> */}
                </div>

                <Table striped bordered hover>
                    <thead>
                        <tr>
                            <th>Type</th>
                            <th>Logo</th>
                            <th>Name</th>
                            <th>Description</th>
                            <th>Delete</th>
                        </tr>
                    </thead>
                    <tbody>
                        {accesses.length ? (
                            accesses.map((access, key) => {
                                return (
                                    <tr key={key}>
                                        <td>
                                            {access.app.appType === 0 && (
                                                <span>
                                                    <img
                                                        src="/images/desktop_black.svg"
                                                        alt="desktop"
                                                        style={{
                                                            width: '25pt',
                                                        }}
                                                    />
                                                </span>
                                            )}
                                            {access.app.appType === 1 && (
                                                <span>
                                                    <img
                                                        src="/images/web_black.svg"
                                                        alt="web"
                                                        style={{
                                                            width: '25pt',
                                                        }}
                                                    />
                                                </span>
                                            )}
                                        </td>
                                        <td>
                                            {access.app.logo && (
                                                <img
                                                    src={asset + access.app.logo}
                                                    alt=""
                                                    style={{
                                                        height: '27pt',
                                                    }}
                                                />
                                            )}
                                            {!access.app.logo && (
                                                <img
                                                    src="/images/placeholder.png"
                                                    alt=""
                                                    style={{
                                                        height: '27pt',
                                                    }}
                                                />
                                            )}
                                        </td>
                                        <td>
                                            {access.app.name}
                                            <i
                                                style={{
                                                    fontSize: '7pt',
                                                    display: 'block',
                                                    fontStyle: 'normal',
                                                }}
                                            >
                                                {access.app.appId}
                                            </i>
                                        </td>
                                        <td>{access.app.description}</td>
                                        <td>
                                            <button
                                                className="btn btn-sm btn-outline-danger"
                                                onClick={() => {
                                                    deleteAccess(access.accessId);
                                                }}
                                            >
                                                <GoTrashcan></GoTrashcan>
                                            </button>
                                        </td>
                                    </tr>
                                );
                            })
                        ) : (
                            <tr>
                                <td colSpan="5">no data</td>
                            </tr>
                        )}
                    </tbody>
                </Table>
            </>

            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Create Access</Modal.Title>
                </Modal.Header>
                <Modal.Body style={{ paddingTop: '0' }}>
                    <Table>
                        <tbody>
                            {apps.length ? (
                                apps
                                    .filter((a) => !accesses.find((ac) => a.appId === ac.appId))
                                    .map((app, key) => {
                                        return (
                                            <tr key={key}>
                                                <td>
                                                    {app.name}
                                                    <i
                                                        style={{
                                                            fontSize: '7pt',
                                                            display: 'block',
                                                            fontStyle: 'normal',
                                                        }}
                                                    >
                                                        {app.appId}
                                                    </i>
                                                </td>
                                                <td>
                                                    <button
                                                        className="btn btn-sm btn-outline-primary"
                                                        onClick={() => {
                                                            createAccess(app.appId);
                                                        }}
                                                    >
                                                        <AiOutlineUserAdd></AiOutlineUserAdd>
                                                        <span className="ml-1">Give Access</span>
                                                    </button>
                                                </td>
                                            </tr>
                                        );
                                    })
                            ) : (
                                <tr>
                                    <td colSpan="2">no data</td>
                                </tr>
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
            </Modal>
        </Fragment>
    );
};

export default Apps;
